export default {
    parse: {
        prelude: null,
        block(nested = false) {
            return this.Block(nested);
        }
    }
};
